import React from 'react';
import { Link } from 'react-router-dom';
import { Category } from '@/types';

interface CategoryCardProps {
  category: Category;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category }) => {
  return (
    <Link to={`/category/${category.id}`} className="block">
      <div className="card-warm group h-full p-7">
        <div className="text-3xl mb-4">
          {category.icon}
        </div>
        <h3
          className="text-base font-semibold mb-2"
          style={{ fontFamily: 'var(--font-serif)', color: 'var(--text-primary)' }}
        >
          {category.name}
        </h3>
        <p
          className="text-sm leading-relaxed mb-5"
          style={{ color: 'var(--text-secondary)' }}
        >
          {category.description}
        </p>
        <div className="flex items-center justify-between">
          <span
            className="text-xs font-semibold tracking-wide uppercase group-hover:underline"
            style={{ color: 'var(--accent-primary)' }}
          >
            Explore
          </span>
          <span className="text-xs" style={{ color: 'var(--text-muted)' }}>
            {category.book_count} {category.book_count === 1 ? 'book' : 'books'}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
